import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import AnimatedRouter from 'components/AnimatedRouter';
import Card from 'components/Card';
import Close from './Close';
import Delete from './Delete';

/**
 * 账户注销
 */
const Logoff: React.FC = () => {
    return (
        <Card page>
            <AnimatedRouter>
                <Route path="close" element={<Close />} />
                <Route path="delete" element={<Delete />} />
                <Route path="*" element={<Navigate to="close" replace />} />
            </AnimatedRouter>
        </Card>
    );
};

export default Logoff;
